import { defineMessages } from 'react-intl';

export default defineMessages({
    generalCoverages: {
        id: 'quoteandbind.ba.directives.MultiQuoteView.General Coverages - Apply to all vehicles',
        defaultMessage: 'General Coverages - Apply to all vehicles',
    },
    vehicleSpecificCoverage: {
        id: 'quoteandbind.ba.directives.MultiQuoteView.Vehicle-',
        defaultMessage: 'Vehicle-Specific Coverages - ',
    },
    baGenerateQuoteDocument: {
        id: 'quoteandbind.ba.directives.Generate Quote Document',
        defaultMessage: 'Generate Quote Document',
    },
    baGenerateQuoteDocumentConf: {
        id: 'quoteandbind.ba.directives.Are you sure you want to generate quote document',
        defaultMessage: 'Are you sure you want to generate quote document',
    },
    baGenerateQuoteSummary: {
        id: 'quoteandbind.ba.directives.Generate Quote Summary',
        defaultMessage: 'Generate Quote Summary',
    },
});
